module.exports = __webpack_public_path__ + "static/media/manufacturing-macrovector_oficial-01 1.21542068.png";